module.exports = __webpack_public_path__ + "static/media/lunch.8236bf21.png";